export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_LOCALE = 'en-US';
export const LOCALE_KEY = 'locale';
export const LANGUAGE_KEY = 'language';
